import AddLocationEventModalView from "./addLocationEventModal.html";

angular.module("events")
    .controller("LocationsEventsListCtrl", ['event','LoginService', '$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', '$stateParams', '$state', '$http', '$window', 'uiGridConstants', 'eventService', 'logService',
        function (event, LoginService, $rootScope, $scope, Restangular, gridService, modalService, $uibModal, $filter, $translate, $stateParams, $state, $http, $window, uiGridConstants, eventService, logService) {

        if(!Array.isArray($scope.$parent.menusItems)) {
            $state.go("events.edit", { id: $stateParams.id });
        } else {
            let results = $scope.$parent.menusItems.filter(m => m.id === parseInt($stateParams.menu_item_id, 10));
            if(results.length > 0) {
                $scope.allowWrite &&= results[0].editable;
                $scope.allowMaterialRead &&= results[0].visible;
            } else {
                $scope.allowWrite = false;
                $scope.allowMaterialRead = false;
            }
        }
            $rootScope.title = $filter('translate')('locations_reservations.locations') + " - " + $filter('translate')('events.locations');
        $rootScope.breadcrumb = [
            { title: $filter('translate')('events.title'), url: "events.list" },
            { title: $filter('translate')('events.title'), url: "events.list" },
            { title: $filter('translate')('locations_reservations.locations') }
        ];
        $scope.classSize = "col-lg-12 col-md-12";

            $scope.event = event;

        $rootScope.breadcrumb = [
            { title: $filter('translate')('events.title'), url: "events.list" },
            { title: $scope.event.name, url: "events.edit({ id: " + $scope.event.id + " })" },
            { title: $filter('translate')('locations_reservations.locations') }
        ];
            $rootScope.title = $scope.event.name + " - " + $filter('translate')('locations_reservations.locations');

            $scope.gridOptionLocations = {
            pdfTitle: $filter('translate')('events.locations.pdf_title'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            //gridMenuShowHideColumns: false,
            enableSorting: true,
            paginationPageSizes: [20, 50, 100],
            paginationPageSize: 20,
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
                { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                { name: 'name', field: 'name', displayName: $filter('translate')('locations.name'), enableFiltering: true, enableHiding: false },
                {
                    name: 'is_external', field: 'is_external', displayName: $filter('translate')('locations.external'),
                    filter: gridService.yesNoFilter('is_external'), width: 100, enableFiltering: true,
                    cellTemplate: gridService.yesNoTemplate('is_external')
                },
                {
                    name: 'is_private', field: 'is_private', displayName: $filter('translate')('locations.is_private'),
                    filter: gridService.yesNoFilter('is_private'), width: 100, enableFiltering: true,
                    cellTemplate: gridService.yesNoTemplate('is_private')
                },
                {
                    name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                        { title: $filter('translate')('general.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.event_location_id, row.entity.name);"', cssIconClass: "fa fa-remove" }
                    ], { cssClass: "pull-right" })
                },

            ],
                getData: function (options) {
                    options.event_id = $stateParams.id;
                    return Restangular.all('eventsLocations').getList(options);
                }
            };

            $scope.event = event;

            $scope.deleteDialog = function (id, name) {
            $scope.id = id;
            modalService.confirm({
                title: $filter('translate')('locations.button_delete'),
                message: $filter('translate')('locations.delete_message') + " " + name + "?",
                onAccept: function () {
                    Restangular.one('EventsLocations', id).remove().then(function () {
                        toastr.success($filter('translate')('events.locations.delete_success'));
                        $scope.gridOptionLocations.loadData(false);

                    }, function (response) {
                        logService.error("Error with status code", response.status);
                    });
                }
            });
        };

            $scope.assignLocation = function (e) {
            let $modalInstance = $uibModal.open({
                animation: true,
                template: AddLocationEventModalView,
                controller: "AssignModalCtrl",
                size: 'md',
                resolve: {
                    event: function () {
                        return $scope.event;
                    }
                }
            });

            //Retorno de los datos desde el moda l.
            $modalInstance.result.then(function () {
                $scope.gridOptionLocations.loadData(false);
            }, function () {
                console.info('Modal dismissed at: ' + new Date());
            });
        };


    }])

    .controller("AssignModalCtrl", ['LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', '$http', '$stateParams', '$q', 'event', function (LoginService, $scope, $uibModalInstance, Restangular, modalService, $filter, $http, $stateParams, $q, event) {

        $scope.selectLocations = [];
        $scope.locations = {};

        Restangular.all('Locations').getList().then(function (locations) {
            $scope.selectLocations = locations;
        });


        $scope.saveLocation = function () {
            
            $scope.locations.event_id = event.id;
            Restangular.all('EventsLocations').customPOST($scope.locations, "SaveLocation", {}).then(function (result) {
                $uibModalInstance.close(result.id);
            });

        }

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

}])




  ;
